export default __webpack_public_path__ + "static/telegram-hero-b4c4f11897ec2d1a3a7f90cc7be7b4bb.png";